import { Button } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Import Link
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function ContentCard(props) {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 600px)');
        const handleResize = (e) => setIsMobile(e.matches);

        // Initial check
        handleResize(mediaQuery);
        mediaQuery.addEventListener('change', handleResize);

        return () => mediaQuery.removeEventListener('change', handleResize);
    }, []);

    const cardStyle = {
        width: isMobile ? '100%' : '15.7rem'
    };

    const imageStyle = {
        width: isMobile ? '100%' : '250px',
        height: '180px',
        objectFit: 'cover',
    };

    return (
        <Card className="cardScale card_scale" style={{ width: cardStyle, margin: "16px" }}>
            <Card.Img variant="top" src={props.image} alt="image..." style={{ width: imageStyle, height: "180px" }} />
            <Card.Body>
                <div className='row g-0'>
                    <div className='col-12'>
                        <Card.Title className='card-title' style={{ textAlign: "center", display: 'grid', marginBottom: "10px", fontFamily: "sans-serif", fontWeight: "bold", fontSize: '15px' }}>
                            {props.name}
                        </Card.Title>
                    </div>
                </div>

                <Link to={`/data-structures/${props.link}`}>
                    <Button variant="outline-success form-control card-btn"><strong>{props.btnname} &nbsp; <FontAwesomeIcon icon={faArrowRight} /></strong></Button>
                </Link>
            </Card.Body>
        </Card>
    );
}
